import React from 'react';
import {
  faGithub,
  faLinkedinIn,
  faTelegram,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Footer() {
  return (
    <footer className="footer">
      <span className="footer__title">find me in:</span>
      <a
        className="footer__link"
        target="_blank"
        rel="noreferrer"
        href="https://www.linkedin.com/in/nicolasolenev/"
      >
        <FontAwesomeIcon icon={faLinkedinIn} />
      </a>
      <a
        className="footer__link"
        target="_blank"
        rel="noreferrer"
        href="https://t.me/nicolasolenev"
      >
        <FontAwesomeIcon icon={faTelegram} />
      </a>
      <a
        className="footer__link"
        target="_blank"
        rel="noreferrer"
        href="https://github.com/nicolasolenev"
      >
        <FontAwesomeIcon icon={faGithub} />
      </a>
    </footer>
  );
}
